/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { RefObject } from 'react';

import { Grid } from '../Grid';
import { useConfiguredGrid, usePortalFiltersReload } from './hooks';

import type { GridProps, GridStore } from '../Grid';

export interface ConfiguredGridProps<RowDataT, TotalRowDataT, FilterT> extends GridProps<RowDataT, TotalRowDataT, FilterT> {
    sectionId?: string;
}

export const ConfiguredGrid = <RowDataT, TotalRowDataT, FilterT>(
    props: ConfiguredGridProps<RowDataT, TotalRowDataT, FilterT>
): React.ReactElement => {
    const {
        sectionId,
        columns,
        api,
        data,
        ...restProps
    } = props;
    const configuredColumns = useConfiguredGrid<RowDataT, TotalRowDataT, FilterT>(sectionId, columns);
    const gridApi = usePortalFiltersReload<RowDataT, TotalRowDataT, FilterT>(api) as RefObject<GridStore<RowDataT, TotalRowDataT, FilterT>>;

    return (
        <Grid
            {...restProps}
            data={requestParams => data(requestParams)}
            columns={configuredColumns}
            api={gridApi}
        />
    );
};
